import React, { useState, useRef, useEffect } from 'react';
import {
  TextField,
  Button,
  CircularProgress,
  Box,
  Container,
  Typography,
} from '@mui/material';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { handleError, validatePassword } from '../utils/lib';
import { useSnackbar } from '../providers/SnackBarProvider';
import { useTranslation } from 'react-i18next';

const LoginForgotPassword2 = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');

  const navigate = useNavigate();
  const showSnackbar = useSnackbar();

  const [isLoading, setIsLoading] = useState(false);

  const [password, setPassword] = useState('');
  const [passwordRepeat, setPasswordRepeat] = useState('');
  
  const [errors, setErrors] = useState({});
  const [refs] = useState({
    password: useRef(null),
    passwordRepeat: useRef(null),
  });

  useEffect(() => {
    // Add a delay to focus to ensure component is fully rendered
    setTimeout(() => {
      if (refs.password.current) {
        refs.password.current.focus();
      }
    }, 100);
  }, []);

  const handleSubmit = async(e) => {
    e.preventDefault();

    if (!validatePassword('password', password, setErrors, refs.password) || 
        !validatePasswordRepeat())
      return;
  
    setIsLoading(true);

    const userData = {
      email: email,
      password: password,
    };

    try {
      const response = await axios.post(`${import.meta.env.VITE_API_URL}users?forgot_account_3`, userData);
      //console.log(response);

      navigate('/');
    } catch (error) {
      handleError(error, showSnackbar);
    } finally {
      setIsLoading(false);
    }
  };

  const validatePasswordRepeat = () => {
    if (password !== passwordRepeat) {
      setErrors(prev => ({ ...prev, passwordRepeat: t('login.passwordsDoNotMatch') }));
      refs.passwordRepeat.current.focus();
      refs.passwordRepeat.current.scrollIntoView({ behavior: "smooth", block: "center" });
      return false;
    }

    setErrors(prev => ({ ...prev, passwordRepeat: '' }));
    return true;
  };

  return (
    <Container maxWidth="sm">
      <Box className="login-container">
        <Box 
          className="login-form" 
          padding={3} 
          boxShadow={3}
          component="form"
          onSubmit={handleSubmit}>
          
          <Typography variant="h6" gutterBottom>
            {t('login.newPassword')}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            {t('login.newPasswordInstructions')}
          </Typography>
          
          <TextField
            label={t('common.password')}
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!errors.password}
            helperText={errors.password}
            inputRef={refs.password}
          />
          <TextField
            label={t('login.repeatPassword')}
            type="password"
            margin="normal"
            fullWidth
            value={passwordRepeat}
            onChange={(e) => setPasswordRepeat(e.target.value)}
            error={!!errors.passwordRepeat}
            helperText={errors.passwordRepeat}
            inputRef={refs.passwordRepeat}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSubmit();
              }
            }}
          />
          
          <Box mt={4}>
            <Button
              variant="contained"
              type="submit"
              color="primary"
              onClick={handleSubmit}
              disabled={isLoading}
              fullWidth
            >
              {isLoading ? <CircularProgress size={24} /> : t('common.continue')}
            </Button>
          </Box>

        </Box>
      </Box>
    </Container>
  );
};

export default LoginForgotPassword2;
